import React, { forwardRef, useEffect, useLayoutEffect, useState,useMemo, useRef } from 'react';
import 'highlight.js/styles/atom-one-dark.css';
import Quill from "quill";
import { debounce } from 'lodash';
import ImageResize from 'quill-image-resize-module-react';
import "./Editor.css";
import 'quill/dist/quill.snow.css';
import { Modal } from 'antd';
import Config from "@/config";
// import Axios from "@/utils/useAxios";
import { request } from '@/utils/useRequest';
import {useCommonStore} from "@/store/useCommonStore";
import axios from "axios";
import {ApiHost} from "../../../config";


//Quill.import('highlight.js');
const Delta = Quill.import('delta');

let Size = Quill.import('attributors/style/size');
Size.whitelist = ['10px', '12px','14px', '16px', '20px', '24px', '36px'];
Quill.register(Size, true);

var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif'];
var Font = Quill.import('formats/font');
Font.whitelist = fonts;
Quill.register(Font, true);

Quill.register('modules/imageResize', ImageResize);

const urls = Config.ApiHost + "/api/v5/private/upload-image-manual";
const fetchPreviewImg = async (id) => {
  // const { axios } = Axios();
  try {
    // let result = await request("/api/v2/private/dept/all", "POST", "json", {});
    const response = await request(Config.ApiHost+`/api/v2/public/file/preview/${id}?returnIcon=true`, "POST", "json", { id: id }, 'blob');
    if (response.status !== 200) {
      throw new Error('Failed to fetch preview');
    }
    const blob = await response.data;
    console.log("response", response);
    const url = URL.createObjectURL(blob);
    return url;
  } catch (error) {
    console.error('Error fetching preview:', error);
  }
};



// 引入源码中的BlockEmbed
const BlockEmbed = Quill.import('blots/block/embed');
// 定义新的blot类型
class WscImageEmbed extends BlockEmbed {
  static create(value) {

    const node = super.create(value);
    node.setAttribute("fileid", value);
    node.setAttribute('contenteditable', 'false');
    node.setAttribute('width', '100%');
    node.setAttribute('class', 'wsc-image-container');
    //   设置自定义html,通过接口获取图片并转成base64显示
    // fetchPreviewImg(value).then(src=>{

    // });
    node.innerHTML = `<img src="${value.toLowerCase().startsWith('http') ? value : Config.ApiHost+value}" alt="${value}" />`;
    //node.innerHTML = "<div>加载中...</div>";

    return node;
  }
  static value(node) {

    return node.attributes["fileid"].value;
  }

}
WscImageEmbed.blotName = 'WscImageEmbed';
//WscImageEmbed.className = 'embed-innerApp';
WscImageEmbed.tagName = 'div';
Quill.register(WscImageEmbed, true);



 // 解析默认值并返回解析结果或者null
 function parseDefaultValue(value) {
  console.log("Editor value", value)
  try {
    const v = JSON.parse(value);
    console.log("Editor value", v, '---origin---', v?.origin, typeof(v?.origin));
    const origin = JSON.parse(v?.origin);
    console.log("Editor value", v, '---origin---',origin, typeof(origin));
    // return v?.origin;
    return origin;
  } catch (error) {
    console.warn(error)
    return null;
  }
}


const Editor = forwardRef(
  ({ readOnly, defaultValue, onChange, onSelectionChange }, ref) => {
      const user = useCommonStore.use.user();
      const headers = useMemo(()=>{
          const headers = {
              'Accept':        'application/json',
          }
          if (user?.auth?.token && user?.auth?.name) {
              headers.Authorization = user?.auth?.name;
              headers.wsctoken = user?.auth?.token;
          }
          return headers;
      }, [user]);

      const containerRef = useRef(null);
    // const onTextChange = (...args) => {
    //     console.log(ref.current.innerHTML);
    //     onChange(...args);
    // }

    const [onTextChange] = useState(() => debounce((...args) => {
      console.log('Logging before calling onChange:', args);
      onChange(JSON.stringify({
        origin: Array.isArray(args) && args.length > 0 ? args[0] :undefined,
        html:ref.current?.getSemanticHTML()}
      ));
    }, 500, { trailing: true }));

    const defaultValueRef = useRef(parseDefaultValue(defaultValue));
    const onTextChangeRef = useRef(onTextChange);
    const onSelectionChangeRef = useRef(onSelectionChange);

    useLayoutEffect(() => {
      onTextChangeRef.current = onTextChange;
      onSelectionChangeRef.current = onSelectionChange;
    });

    useEffect(() => {
      ref.current?.enable(!readOnly);
    }, [ref, readOnly]);

    useEffect(() => {
      const container = containerRef.current;
      const editorContainer = container.appendChild(
        container.ownerDocument.createElement('div'),
      );

      const quill = new Quill(editorContainer, {
        theme: 'snow',
          debug: 'warn',
          modules: {
              history: {          // Enable with custom configurations
                  delay: 2500,
                  userOnly: true
              },
              syntax: true,        // Enable with default configuration
              toolbar: [
                  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                  ['blockquote', 'code-block'],
                  ['link', 'image', 'video', 'formula'],

                  [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                  [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
                  [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                  [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                  [{ 'direction': 'rtl' }],                         // text direction

                  [{ 'size': ['10px', '12px', '14px', '16px', '20px', '24px', '36px'] }],  // custom dropdown
                  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                  [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                  [{ 'font': ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif'] }],
                  [{ 'align': [] }],

                  // remove formatting button
              ],
              imageResize: {
                  parchment: Quill.import('parchment'),
                  modules: ['Resize', 'DisplaySize']
              },
              uploader: {
                  handler(range, files ) {
                      if (!this.quill.scroll.query('image')) {
                          return;
                      }
                      console.log('uploader handler', range, files);
                      const promises = files.map((file) => {
                          return new Promise((resolve) => {
                              // 修改为上传文件并返回文件url
                              const formData = new FormData();
                              formData.append('image', file);
                              axios.post(urls, formData, headers).then(resp => {
                                  console.log(resp);
                                  if (resp.status === 200 && resp.data.success && Array.isArray(resp.data.data) && resp.data.data.length > 0) {
                                    resolve(ApiHost + resp.data.data[0].url);
                                  }
                                  resolve(null);
                              }).catch(err => {
                                  console.warn(err);
                                  resolve(null);
                              });
                          });
                      });
                      Promise.all(promises).then((images) => {
                          console.log('uploader handler all done', images);
                          const update = images.reduce((delta, image) => {
                              // if (image) return delta.insert({image}, { width: '100%', height: '100%' });
                              if (image) return delta.insert({ WscImageEmbed: image }, {
                                  // width: '100%', height: '100%'
                              });
                              //insert({image}, { width: '100%', height: '100%' });
                              // if (image) {
                              //     return delta.concat(new Delta().insert(
                              //         {image},
                              //             {
                              //               width: '100%',
                              //               height: '100%'
                              //             }
                              //     ));
                              // }
                              return delta;
                          }, new Delta().retain(range.index).delete(range.length)) ;
                          this.quill.updateContents(update, 'user');
                          this.quill.setSelection(
                              range.index + images.length,
                              'silent',
                          );
                      });
                  },
              }
          }
      });


      /**
       * 选择本地文件
       *
       */
      function selectLocalImage() {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.click();

        input.onchange = () => {
          const file = input.files[0];

          if (/^image\//.test(file.type)) {
            saveToServer(file);
          } else {
            Modal.error({ content: "只能选择图片文件上传！" });
          }
        };
      }

      /**
       * 上传文件
       *
       * @param {File} file
       */
      function saveToServer(file) {
        const fd = new FormData();
        fd.append('image', file);

        const xhr = new XMLHttpRequest();
        xhr.open('POST', urls, true);
        xhr.onload = () => {
          if (xhr.status === 200) {
            // 上传完成返回内容

            const data = JSON.parse(xhr.responseText).data;
            if(data.length > 0) {
              insertToEditor(data[0].url);
            }

          }
        };
        xhr.send(fd);
      }

      /**
       * 图片插入编辑器
       *
       * @param {string} url
       */
      function insertToEditor(obj) {
        const range = quill.getSelection();
        quill.insertEmbed(range.index, 'WscImageEmbed', obj);
      }



      const toolbar = quill.getModule("toolbar");
      toolbar.addHandler('image', ()=>{
        selectLocalImage();
      });
      ref.current = quill;

      if (defaultValueRef.current) {
        //quill.clipboard.dangerouslyPasteHTML(defaultValueRef.current);
        quill.setContents(defaultValueRef.current);
      }

      quill.on(Quill.events.TEXT_CHANGE, (...args) => {
        const delta = quill.getContents();
        onTextChangeRef.current?.(JSON.stringify(delta));
      });

      quill.on(Quill.events.SELECTION_CHANGE, (...args) => {
        onSelectionChangeRef.current?.(...args);
      });

      return () => {
        ref.current = null;
        container.innerHTML = '';
      };
    }, [ref]);

    return <div ref={containerRef}></div>;
  },
);

Editor.displayName = 'Editor';

export default Editor;